//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "questionList",
    data() {
        return {
            pageSize: 15,
            currentPage: 1,
            totalCount: 0,
            list: []
        }
    },
    methods: {
        getPage() {
            var memberId = localStorage.getItem('MemberId');
            if (parseInt(memberId) > 0) {
                let page = {
                    memberId: parseInt(memberId),
                    maxResultCount: this.pageSize,
                    skipCount: (this.currentPage - 1) * this.pageSize
                };
                abp.ajax.post('/api/services/app/Questionnaire/SearchCanAnswerQuestionnaire', page).then(res => {
                    this.list = [];
                    this.list.push(...res.data.result.items);
                    this.totalCount = res.data.result.totalCount;
                })
            }
        }
    },
    created() {
        this.getPage()
    }
}
